import Vue from 'vue'
import {getBlob, postBlob} from "@/plugins/axios";

export function getDashboardSummary(data) {
  return Vue.axios({
    url: '/api/dashboard/summary',
    method: 'get',
    params: {...data}
  })
}

export function getBackMoney(data) {
  return Vue.axios({
    url: '/api/dashboard/backMoney',
    method: 'get',
    params: {...data}
  })
}

export function getCompareMonthSummary(data) {
  return Vue.axios({
    url: '/api/dashboard/compareMonthSummary',
    method: 'post',
    data: {...data}
  })
}


export function getSummaryMonthly(data) {
  return Vue.axios({
    url: '/api/dashboard/summaryMonthly',
    method: 'get',
    params: {...data}
  })
}

export function getCompareYearSummary(data) {
  return Vue.axios({
    url: '/api/dashboard/compareYearSummary',
    method: 'post',
    data: {...data}
  })
}

export function getDashboardSale(data) {
  return Vue.axios({
    url: '/api/dashboard/sale',
    method: 'get',
    params: {...data}
  })
}

export function getDashboardExecutor(data) {
  return Vue.axios({
    url: '/api/dashboard/executor',
    method: 'get',
    params: {...data}
  })
}

export function getDashboardPlatform(data) {
  return Vue.axios({
    url: '/api/dashboard/platform',
    method: 'get',
    params: {...data}
  })
}

export function getDashboardCustomer(data) {
  return Vue.axios({
    url: '/api/dashboard/customer',
    method: 'get',
    params: {...data}
  })
}

export function getDashboardArtist(data) {
  return Vue.axios({
    url: '/api/dashboard/artist',
    method: 'get',
    params: {...data}
  })
}

export function getDashboardArtistMonth(data) {
  return Vue.axios({
    url: '/api/dashboard/artist_month',
    method: 'get',
    params: {...data}
  })
}

export function getDashboardArtistPlatformMonth(data) {
  return Vue.axios({
    url: '/api/dashboard/artist_platform_month',
    method: 'get',
    params: {...data}
  })
}

//导出（公共）
export function dashboardDownload(data) {
  return getBlob('/api/dashboard/export', data)
}

export function dashboardOrderDownload(data) {
  return getBlob('/api/dataSummary/order_export', data)
}

export function getDashboardBrand(data) {
  return Vue.axios({
    url: '/api/dashboard/brand',
    method: 'get',
    params: {...data}
  })
}

export function getDashboardBrandCompare(data) {
  return Vue.axios({
    url: '/api/dashboard/brandCompare',
    method: 'post',
    data
  })
}

export function getDashboardBrandTrade(data) {
  return Vue.axios({
    url: '/api/dashboard/brandTrade',
    method: 'get',
    params: {...data}
  })
}

export function getDashboardBrandCategory(data) {
  return Vue.axios({
    url: '/api/dashboard/brandCategory',
    method: 'get',
    params: {...data}
  })
}

//品牌集团维度
export function getDashboardBrandCombines(data) {
  return Vue.axios({
    url: '/api/dashboard/brandCombines',
    method: 'post',
    data
  })
}

//品牌集团维度 年度
export function getDashboardBrandCombinesYear(data) {
  return Vue.axios({
    url: '/api/dashboard/brandCombinesYear',
    method: 'post',
    data
  })
}

export function getDashboardCombineBrandList(data) {
  return Vue.axios({
    url: '/api/dashboard/combineBrandList',
    method: 'post',
    data
  })
}

export function getDashboardPlatformsData(data) {
  return Vue.axios({
    url: '/api/dashboard/platformsData',
    method: 'get',
    params: {...data}
  })
}

export function getDashboardCustomerBrandData(data) {
  return Vue.axios({
    url: '/api/dashboard/customerBrandData',
    method: 'get',
    params: {...data}
  })
}

export function getDashboardBrandArtistRank(data) {
  return Vue.axios({
    url: '/api/dashboard/brandArtistBrank',
    method: 'get',
    params: {...data}
  })
}

export function platformCount(data) {
  return Vue.axios({
    url: '/api/dashboard/platformCount',
    method: 'get',
    params: {...data}
  })
}

export function platformMoney(data) {
  return Vue.axios({
    url: '/api/dashboard/platformMoney',
    method: 'get',
    params: {...data}
  })
}

export function customerPrePrice(data) {
  return Vue.axios({
    url: '/api/dashboard/customerPrePrice',
    method: 'get',
    params: {...data}
  })
}

export function artistBrand(data) {
  return Vue.axios({
    url: '/api/dashboard/artistBrand',
    method: 'get',
    params: {...data}
  })
}

export function orderSource(data) {
  return Vue.axios({
    url: '/api/dashboard/orderSource',
    method: 'get',
    params: {...data}
  })
}

export function orderWorkForm(data) {
  return Vue.axios({
    url: '/api/dashboard/orderWorkForm',
    method: 'get',
    params: {...data}
  })
}

export function platformDetailMonth(data) {
  return Vue.axios({
    url: '/api/dashboard/platformDetailMonthData',
    method: 'get',
    params: {...data}
  })
}

export function platformDetailOrder(data) {
  return Vue.axios({
    url: '/api/dashboard/platformDetailOrder',
    method: 'get',
    params: {...data}
  })
}

export function platformDetailBrand(data) {
  return Vue.axios({
    url: '/api/dashboard/platformDetailBrand',
    method: 'get',
    params: {...data}
  })
}

export function platformDetailArtist(data) {
  return Vue.axios({
    url: '/api/dashboard/platformDetailArtist',
    method: 'get',
    params: {...data}
  })
}

export function platformDetailTrade(data) {
  return Vue.axios({
    url: '/api/dashboard/platformDetailTrade',
    method: 'get',
    params: {...data}
  })
}

//导出-平台的单量/订单金额
export function exportPlatformDetail(data) {
  return postBlob('/api/dashboard/platformDetailExport', data)
}

export function executorAllMonth(data) {
  return Vue.axios({
    url: '/api/dashboard/executorAllMonth',
    method: 'get',
    params: {...data}
  })
}

export function detailArtist(data) {
  return Vue.axios({
    url: '/api/dashboard/detailArtist',
    method: 'get',
    params: {...data}
  })
}

export function sanKeyOrderCount(data) {
  return Vue.axios({
    url: '/api/dashboard/sanKeyOrderCount',
    method: 'get',
    params: {...data}
  })
}

export function customerDetailMonthlySum(data) {
  return Vue.axios({
    url: '/api/dashboard/customerDetailMonthlySum',
    method: 'get',
    params: {...data}
  })
}

/**
 * 更新指定月份仪表盘报表数据
 * @param data
 * @returns {*}
 */
export function runDashBoardScript(data) {
  return Vue.axios({
    url: '/api/dashboard/run_script',
    method: 'get',
    params: {...data}
  })
}

export function getLastRunDashBoardScript(data) {
  return Vue.axios({
    url: '/api/dashboard/last_run_script',
    method: 'get',
    params: {...data}
  })
}

export function saleDetailMonthlySum(data) {
  return Vue.axios({
    url: '/api/dashboard/saleDetailMonthlySum',
    method: 'get',
    params: {...data}
  })
}

export function getDashboardPlatformsDataV2(data) {
  return Vue.axios({
    url: '/api/dashboard/platformsDataV2',
    method: 'get',
    params: {...data}
  })
}

export function salePrePrice(data) {
  return Vue.axios({
    url: '/api/dashboard/salePrePrice',
    method: 'get',
    params: {...data}
  })
}

export function detailArtistV2(data) {
  return Vue.axios({
    url: '/api/dashboard/detailArtistV2',
    method: 'get',
    params: {...data}
  })
}

export function detailBrandV2(data) {
  return Vue.axios({
    url: '/api/dashboard/detailBrandV2',
    method: 'get',
    params: {...data}
  })
}

//品牌产地维度
export function getDashboardBrandPlaceOfOrigin(data) {
  return Vue.axios({
    url: '/api/dashboard/placeOfOrigin',
    method: 'post',
    data
  })
}

export function getDashboardSaleTargetAmountList(data) {
  return Vue.axios({
    url: '/api/dashboard/saleTargetAmountList',
    method: 'get',
    params: {...data}
  })
}

export function getDashboardCombineBrandItem(data) {
  return Vue.axios({
    url: '/api/dashboard/brandCombinesItem',
    method: 'post',
    data
  })
}
